import { Route, Routes, Navigate } from "react-router-dom";

import PageContent from "components/partials/page-content/page-content";
import ApprovalQueue from "containers/admin/clients/client/approval-queue/approval-queue";
import Batch from "containers/admin/clients/client/approval-queue/batch-details/batch-details";

import { Route as AppRoute } from "utilities/app-routes";

const ApprovalQueueRoutes = () => {
  return (
    <Routes>
      <Route
        index
        element={
          <PageContent fixedContent>
            <ApprovalQueue />
          </PageContent>
        }
      />
      <Route
        path={`${AppRoute.batch}/:id/*`}
        element={
          <PageContent fixedContent>
            <Batch />
          </PageContent>
        }
      />
      <Route path="*" element={<Navigate to=".." replace />} />
    </Routes>
  );
};

export default ApprovalQueueRoutes;
